import { IBaseModel, BaseModel } from '../base.model' ;

export interface IApartment extends IBaseModel {

    block? : number;
    num_apartment?: number;
    tenant?: number[];
    owner?: number[];
    floor?: number;
    surface?: number;
    type?: string;
    apartment_as_block?: any;
}

export class ApartmentDto extends BaseModel implements IBaseModel {

    block? : number
    num_apartment?: number
    tenant?: number[]
    owner?: number[]
    floor?: number
    surface?: number
    type?: string
    apartment_as_block?: any

    constructor(opts?: IApartment){
        super(opts)
      this.tenant = []
      this.owner = []
      if (opts) {
        this.tenant = opts.tenant || []
        this.owner = opts.owner || []
      }
    }
}



// WEBPACK FOOTER //
// ./src/models/apartment/apartment.model.ts